import React, { useState, } from 'react';
import { Box, Typography, IconButton, Divider, Collapse, useTheme, Button } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css'; // Import default styles
import { useSelector } from 'react-redux';


const NotificationContainer = () => {
    const theme = useTheme();
    const notifications = useSelector((state) => state.notifications.notifications);
    // Manually assigning camelCase variables
    const quickLinks = notifications.quick_links || [];
    const studyTips = notifications.study_tips || [];
    const referenceMaterials = notifications.reference_materials || [];
    const personalizedSuggestions = notifications.personalized_suggestions || [];
    const motivationalQuote = notifications.motivational_quote || {};

    const [open, setOpen] = useState(false);
    const [content, setContent] = useState('');

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSave = (savedContent) => {
        console.log('Saved Content:', savedContent);
        setContent(savedContent);
        setOpen(false);
    };


    const [expandedSections, setExpandedSections] = useState({
        studyTips: true,
        quickLinks: true,
        referenceMaterials: true,
        personalizedSuggestions: true,
        motivationalQuote: true,
    });

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
    };


    if (notifications.length === 0) {
        return null;
    }

    return (
        <ResizableBox
            width={500} // Initial width
            // height={400} // Initial height (optional)
            minConstraints={[400]} // Minimum width and height
            maxConstraints={[700, Infinity]} // Maximum width and height
            axis="x" // Allow resizing only horizontally; use "both" for both dimensions
            resizeHandles={['w']} // Handle for resizing (west direction)
            handle={
                <span
                    className="custom-handle"
                    style={{
                        width: '2px', // Width of the handle
                        cursor: 'ew-resize', // Indicating it's resizable horizontally
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        height: '100%',
                        backgroundColor: theme.palette.grey.A100, // Neutral color to blend with the background
                        borderRadius: '4px', // Rounded corners for a softer look
                        transition: 'background-color 0.2s ease', // Smooth color transition
                    }}
                    onMouseEnter={(e) => {
                        // Change color when hovering
                        e.target.style.backgroundColor = theme.palette.primary.main; // Darker shade on hover
                    }}
                    onMouseLeave={(e) => {
                        // Reset color when not hovering
                        e.target.style.backgroundColor = theme.palette.grey.A100;
                    }}
                />
            }
            sx={{
                border: 1,
                borderRadius: 1,
                // backgroundColor: '#fff', // Adjust as per your theme
                position: 'relative',
                height: "100%",
                // marginRight: -1,
            }}
        >
            <Scrollbars autoHide style={{ height: '100%' }}>
                {false && (

                    <Box
                        sx={{
                            padding: '12px 16px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: 1,
                            borderColor: 'divider',
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            Highlights
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={() => { }}
                            sx={{
                                color: 'text.secondary',
                                '&:hover': { color: 'primary.dark', backgroundColor: 'transparent' },
                            }}
                        >
                            {/* <CloseIcon fontSize="small" /> */}
                        </IconButton>
                    </Box>
                )}

                <Box sx={{ padding: 1 }}>
                    {/* Quick Links (Collapsible) */}
                    {false && quickLinks && quickLinks.length > 0 && (
                        <Box
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                paddingTop: 1,
                            }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'primary.dark'
                                    }}
                                >
                                    Quick Links
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSection('quickLinks')}
                                    sx={{
                                        color: 'text.secondary',
                                        '&:hover': { color: 'primary.dark' }
                                    }}
                                >
                                    {expandedSections.quickLinks ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Box>

                            <Collapse in={expandedSections.quickLinks}>
                                <Box sx={{
                                    display: 'grid',
                                    gap: 1, // Adds spacing between links
                                }}>
                                    {quickLinks.map((link, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                padding: '10px 12px',
                                                borderRadius: '6px',
                                                // boxShadow: 1,
                                                backgroundColor: 'grey.A100',
                                                // border: '1px solid',
                                                borderColor: 'primary.light',
                                                transition: 'background-color 0.2s ease, color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                }
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                component="a"
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {link.title}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>
                        </Box>

                    )}


                    {/* Study Tips (Collapsible) */}
                    {studyTips && studyTips.length > 0 && (
                        <Box
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                paddingTop: 1,
                            }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'primary.dark'
                                    }}
                                >
                                    Study Tips
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSection('studyTips')}
                                    sx={{
                                        color: 'text.secondary',
                                        '&:hover': { color: 'primary.dark' }
                                    }}
                                >
                                    {expandedSections.studyTips ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Box>

                            <Collapse in={expandedSections.studyTips}>
                                <Box sx={{
                                    display: 'grid',
                                    gap: 1, // Adds spacing between each tip
                                }}>
                                    {studyTips.map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                padding: '10px 12px',
                                                borderRadius: '6px',
                                                backgroundColor: 'grey.A100',
                                                // border: '1px solid',
                                                borderColor: 'primary.light', // Same as Reference Materials
                                                // boxShadow: 1,
                                                transition: 'background-color 0.2s ease, color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                }
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {item.tip}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>
                        </Box>
                    )}

                    {/* Reference Materials (Collapsible) */}
                    {false && referenceMaterials && referenceMaterials.length > 0 && (
                        <Box
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                paddingTop: 1,
                            }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'primary.dark'
                                    }}
                                >
                                    Reference Materials
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSection('referenceMaterials')}
                                    sx={{
                                        color: 'text.secondary',
                                        '&:hover': { color: 'primary.dark' }
                                    }}
                                >
                                    {expandedSections.referenceMaterials ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Box>

                            <Collapse in={expandedSections.referenceMaterials}>
                                <Box sx={{
                                    display: 'grid',
                                    gap: 1, // Adds spacing between links
                                }}>
                                    {referenceMaterials.map((ref, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                padding: '10px 12px',
                                                borderRadius: '6px',
                                                // boxShadow: 1,
                                                backgroundColor: 'grey.A100',
                                                // border: '1px solid',
                                                borderColor: 'primary.light',
                                                transition: 'background-color 0.2s ease, color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                }
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                component="a"
                                                href={ref.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {ref.title}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>
                        </Box>
                    )}


                    {/* Personalized Suggestions (Collapsible) */}
                    {personalizedSuggestions && personalizedSuggestions.length > 0 && (
                        <Box
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                paddingTop: 1,
                            }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'primary.dark'
                                    }}
                                >
                                    Personalized Suggestions
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSection('personalizedSuggestions')}
                                    sx={{
                                        color: 'text.secondary',
                                        '&:hover': { color: 'primary.dark' }
                                    }}
                                >
                                    {expandedSections.personalizedSuggestions ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Box>

                            <Collapse in={expandedSections.personalizedSuggestions}>
                                <Box sx={{
                                    display: 'grid',
                                    gap: 1 // Adds spacing between items
                                }}>
                                    {personalizedSuggestions.map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                padding: '10px 12px',
                                                borderRadius: '6px',
                                                // boxShadow: 1,
                                                backgroundColor: 'grey.A100',
                                                // border: '1px solid',
                                                borderColor: 'primary.light',
                                                transition: 'background-color 0.2s ease, color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                }
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: 'inherit',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                • {item.suggestion}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>
                        </Box>
                    )}


                    {/* Motivational Quote (Collapsible) */}
                    {motivationalQuote && motivationalQuote.quote && motivationalQuote.author && (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    paddingTop: 1,
                                    // borderBottom: '1px solid #e0e0e0'
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'primary.dark'
                                    }}
                                >
                                    Motivational Quote
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSection('motivationalQuote')}
                                    sx={{
                                        color: 'text.secondary',
                                        '&:hover': { color: 'primary.dark' }
                                    }}
                                >
                                    {expandedSections.motivationalQuote ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Box>

                            <Collapse in={expandedSections.motivationalQuote}>
                                <Box
                                    sx={{
                                        paddingX: 2,
                                        paddingY: 1,
                                        borderRadius: 2,
                                        boxShadow: 1,
                                        backgroundColor: 'grey.A100',
                                        borderLeft: '4px solid',
                                        borderColor: 'primary.main',
                                        marginTop: '8px',
                                        transition: 'background-color 0.2s ease'
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontStyle: 'italic',
                                            fontWeight: 'medium',
                                            color: 'text.primary',
                                            marginBottom: '8px'
                                        }}
                                    >
                                        "{motivationalQuote.quote}"
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            textAlign: 'right',
                                            color: 'text.secondary',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        - {motivationalQuote.author}
                                    </Typography>
                                </Box>
                            </Collapse>

                            {/* <Divider sx={{ margin: '10px 0' }} /> */}
                        </>
                    )}


                </Box>
            </Scrollbars>
        </ResizableBox>
    );
};

export default NotificationContainer;
